export const getIdString = (id: string | undefined | null) => {
  if (!id || typeof id !== 'string') return ''
  return id.replace(/ /g, '-').toLowerCase()
}
